export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";